export const SHOW_ECO_DATA = process.env.NEXT_PUBLIC_SHOW_ECO_DATA === 'true';
export const USE_ANCAP_UPLIFT = process.env.NEXT_PUBLIC_USE_ANCAP_UPLIFT === 'true';
